
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Hooks/useWindowScroll.html",
      function () {
        return require("private-next-pages/Hooks/useWindowScroll.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Hooks/useWindowScroll.html"])
      });
    }
  